export default __webpack_public_path__ + "static/media/gallery - draught of living death_02.0dfa77e7.jpg";